// Theme import file.

// Import JS here
import './javascript/theme.js';

// Import SCSS here
import './scss/theme.scss';
